import React from "react";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

interface MyDateInputProps {
  maxWidth?: number;
  value: string | null;
  onChange?: (val: string | null) => void;
}

export default function InputDatePicker({
  value,
  onChange,
  maxWidth = 0,
}: MyDateInputProps) {
  const handleChange = (date: Dayjs | null): void => {
    onChange?.(date ? date.format("DD-MM-YYYY") : null);
  };

  return (
    <>
      <DatePicker
        inputReadOnly
        className="datepicker border border-success"
        format={{ format: "DD-MM-YYYY", type: "mask" }}
        placeholder="DD-MM-YYYY"
        value={value ? dayjs(value, "DD-MM-YYYY") : null}
        onChange={handleChange}
        style={{
          width: "100%",
          height: "34px",
          border: "1px solid #dee2e6",
          ...(maxWidth && { maxWidth: `${maxWidth}px` }),
        }}
      />
    </>
  );
}
//   const getValue = (): Dayjs | null => {
//     if (!value) return null;
//     const parsed = dayjs(value, DATE_FORMAT, true);
//     return parsed.isValid() ? parsed : null;
//   };
